export enum $salesforceAccount {
  id = 'Id',
  name = 'Name',
}
